import { motion } from "framer-motion";
import { Sprout, Lightbulb, Flame, Factory, Zap, Landmark } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";

const POINTS = [
  { icon: Sprout, title: "Quality Ingredients", desc: "Real soya, spinach, beetroot and hand-picked spices in every batch." },
  { icon: Lightbulb, title: "Innovative Recipes", desc: "Reinventing the Indian snack for a smarter, modern palate." },
  { icon: Flame, title: "Bold Flavours", desc: "Piri Piri, Tango Tomato, Palak & Beetroot — nothing subtle here." },
  { icon: Factory, title: "Modern Preparation", desc: "Baked then lightly fried with a less-oil process for real crunch." },
  { icon: Zap, title: "Convenient Snacking", desc: "Resealable jars built for desk, gym-bag and travel moments." },
  { icon: Landmark, title: "Indian Taste, Modern Identity", desc: "Rooted in Indian flavour, styled for the world." },
];

export default function WhyDignity() {
  return (
    <section id="why" className="relative overflow-hidden bg-forest py-24 lg:py-32" data-testid="why-dignity-section">
      <div className="absolute inset-0 grain opacity-50" />
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <Overline>The Dignity Difference</Overline>
          <h2 className="mt-3 max-w-3xl font-display text-5xl leading-none tracking-tight text-cream sm:text-7xl lg:text-8xl">
            WHY <span className="text-gold-gradient">DIGNITY</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {POINTS.map((p, i) => (
            <motion.div key={p.title}
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ delay: i * 0.06, duration: 0.6 }}
              className="group rounded-3xl border border-white/10 bg-black/30 p-8 transition-colors hover:border-gold/40"
              data-testid={`why-point-${i}`}>
              <div className="grid h-12 w-12 place-items-center rounded-xl border border-gold/30 text-gold transition-colors group-hover:gold-gradient group-hover:text-black">
                <p.icon size={22} />
              </div>
              <h3 className="mt-5 font-oswald text-xl uppercase tracking-wide text-cream">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/50">{p.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
